
import XIcon from './Icons/XIcon.vue'
import ScreenUtils from './Mixins/ScreenUtils.js'

export default {
    name: 'Modal',
    components: { XIcon },
    mixins: [ScreenUtils],
    props: {
        headerHeight: Number,
        headerBgColor: {
            type: String,
            default: () => 'bg-brand-25'
        },
        isBgDark: {
            type: Boolean,
            default: true
        },
        placement: {
            type: String,
            default: 'center',
            validator: value => ['center', 'left-bottom'].includes(value)
        },
        width: {
            type: String,
            default: 'w-full md:w-2/3 xl:w-1/2',
        },
        size: {
            type: String,
            default: 'w-full md:w-2/3 xl:w-1/2',
            validator: value => ['sm', 'md', 'lg'].includes(value)
        }
    },
    created () {
        if (this.isBgDark) {
            document.body.style.overflow = 'hidden'
        }
    },
    destroyed () {
        if (this.isBgDark) {
            document.body.style.overflow = 'visible'
        }
    }
}
